import { BaseCdnUrl, CdnArea } from './common.helper';
import { ImageContainer } from './prod-images.helper';
import { SampleType } from './storybook-cdn.helper';

const makeUrl = (area: string, container: string, fileName: string) => {
  return `${BaseCdnUrl}/${area}/${container}/${fileName}`;
};

export const XemploCdn = {
  BaseUrl: BaseCdnUrl,
  MakeCustomUrl: makeUrl,
  Storybook: (container: SampleType, fileName: string) => {
    return makeUrl(CdnArea.Storybook, container, fileName);
  },
  Images: (container: ImageContainer, fileName: string) => {
    return makeUrl(CdnArea.Image, container, fileName);
  },
};

/**
 * @deprecated Keeping this for backward compatibility
 * Use `XemploCdn.Images` instead
 */
export const CdnImage = (container: ImageContainer, fileName: string) => {
  return XemploCdn.Images(container, fileName);
};
